export interface MenuPlacementInput {
  triggerY: number;
  triggerHeight: number;
  windowHeight: number;
  optionCount: number;
  rowHeight?: number;
  gap?: number;
  margin?: number;
  hardCap?: number;
}

export interface MenuPlacement {
  dropUp: boolean;
  maxHeight: number;
}

const DEFAULT_ROW_HEIGHT = 48;
const DEFAULT_GAP = 4;
const DEFAULT_MARGIN = 8;
const DEFAULT_HARD_CAP = 320;
const MENU_BORDERS = 2;

export function computeMenuPlacement({
  triggerY,
  triggerHeight,
  windowHeight,
  optionCount,
  rowHeight = DEFAULT_ROW_HEIGHT,
  gap = DEFAULT_GAP,
  margin = DEFAULT_MARGIN,
  hardCap = DEFAULT_HARD_CAP,
}: MenuPlacementInput): MenuPlacement {
  const desired = Math.min(optionCount * rowHeight + MENU_BORDERS, hardCap);
  const spaceBelow = windowHeight - (triggerY + triggerHeight) - gap - margin;
  const spaceAbove = triggerY - gap - margin;

  if (desired <= spaceBelow) {
    return { dropUp: false, maxHeight: Math.min(hardCap, spaceBelow) };
  }
  if (desired <= spaceAbove) {
    return { dropUp: true, maxHeight: Math.min(hardCap, spaceAbove) };
  }

  const dropUp = spaceAbove > spaceBelow;
  const available = dropUp ? spaceAbove : spaceBelow;
  return { dropUp, maxHeight: Math.max(0, Math.min(hardCap, available)) };
}
